__turbopack_context__.v({
  "card-link__action": "uW0GEW_card-link__action",
  "card-link__content": "uW0GEW_card-link__content",
  "card-link__image": "uW0GEW_card-link__image",
});
